import React from "react";

import Dropzone from "core/Dropzone";

import usePhotoUploadDropzone from "./usePhotoUploadDropzone";
import { useUploadsCurrentlyProcessing } from "../PhotoUploadCore/hooks";

const PhotoUploadDropzone = () => {
    const { dropzoneProps } = usePhotoUploadDropzone();
    const { count: currentlyProcessingCount } = useUploadsCurrentlyProcessing();

    return (
        <>
            <Dropzone
                {...dropzoneProps}
                currentlyProcessingUploads={!!currentlyProcessingCount}
            />
        </>
    );
};

export default PhotoUploadDropzone;
